import { Id, LaravelResponse } from "@dgs/core";
import axios from "axios";
import {
	SelectableTravelSegmentIndexResource,
	TravelDirection,
	TravelSegmentSearchRequest,
} from "../types/travelSegment";

const baseKey = ["travel-segments"];

export const travelSegmentService = {
	baseKey,
	travelSegmentByDirectionKey: (
		registrationFormId: Id,
		direction: TravelDirection,
		request: TravelSegmentSearchRequest,
	) => [...baseKey, registrationFormId, direction, request],
	travelSegmentByDirection: (
		registrationFormId: Id,
		direction: TravelDirection,
		request: TravelSegmentSearchRequest,
	) => {
		const params: Record<string, string> = {};
		if (request.type) {
			params.type = request.type;
		}
		if (request.guestId) {
			params.guestId = `${request.guestId}`;
		}
		if (request.search) {
			params.search = request.search;
		}

		params.withPublicScope = request.withPublicScope ? "1" : "0";

		return axios.get<LaravelResponse<SelectableTravelSegmentIndexResource[]>>(
			`registration-forms/${registrationFormId}/travel-segments/${direction}`,
			{
				params,
			},
		);
	},
};
